import Vue from 'vue';

export default {
  namespaced: true,

  state: {
    compositeCustomersList: [],
    currentCompositeCustomer: {
      id: null,
      name: '',
      dashboards: [],
      selectedDashboardId: null,
    },
    emptyCompositeCustomer: {
      id: null,
      name: '',
      dashboards: [],
      selectedDashboardId: null,
    },
  },

  getters: {
    compositeCustomersList(state) {
      return state.compositeCustomersList;
    },

    currentCompositeCustomer(state) {
      return state.compositeCustomersList.length
        ? state.compositeCustomersList[0]
        : {
          id: null,
          name: '',
          dashboards: [],
          selectedDashboardId: null,
        };
    },

    pagesAccess(state, getters, rootState) {
      return rootState.auth.pages;
    },
  },

  mutations: {
    SET_COMPOSITE_CUSTOMERS_LIST(state, compositeCustomersList) {
      state.compositeCustomersList = compositeCustomersList;
    },

    SET_CURRENT_COMPOSITE_CUSTOMER(state, currentCompositeCustomer) {
      state.currentCompositeCustomer = currentCompositeCustomer;
    },
  },

  actions: {
    updatePagesAccess({ commit }, pagesAccess) {
      commit('auth/SET_PAGES', pagesAccess, { root: true });
    },

    async resetCompositeCustomersList({
      dispatch, commit, state, getters,
    }) {
      const response = await Vue.prototype.$requestHelpers
        .get('api/admin/compositeCustomer/list');

      const compositeCustomersList = response.data.map(
        (el) => ({
          id: el.id,
          name: el.name,
          label: el.name,
          dashboards: Array.isArray(el.dashboards) ? el.dashboards : [],
          selectedDashboardId: Array.isArray(el.dashboards) && el.dashboards.length
            ? el.dashboards[0].id
            : null,
        }),
      );

      commit('SET_COMPOSITE_CUSTOMERS_LIST', compositeCustomersList);

      let { currentCompositeCustomer } = state;

      if (!state.compositeCustomersList.length) {
        currentCompositeCustomer = JSON.parse(JSON.stringify(state.emptyCompositeCustomer));

        if (getters.pagesAccess?.analytics) {
          dispatch('updatePagesAccess', { ...getters.pagesAccess, analytics: false });
        }
        // eslint-disable-next-line max-len
      } else {
        if (!getters.pagesAccess?.analytics) {
          dispatch('updatePagesAccess', { ...getters.pagesAccess, analytics: true });
        }

        // eslint-disable-next-line max-len
        const matchedCompositeCustomer = state.compositeCustomersList
          .find((el) => el.id === state.currentCompositeCustomer.id);

        if (!matchedCompositeCustomer) {
          // eslint-disable-next-line prefer-destructuring
          currentCompositeCustomer = state.compositeCustomersList[0];
        } else {
          currentCompositeCustomer = {
            ...matchedCompositeCustomer,
            selectedDashboardId: matchedCompositeCustomer.dashboards
            // eslint-disable-next-line max-len
              .some((dashboard) => dashboard.id === state.currentCompositeCustomer.selectedDashboardId)
              ? state.currentCompositeCustomer.selectedDashboardId
              : (matchedCompositeCustomer.dashboards[0]?.id ?? null),
          };
        }
      }

      commit('SET_CURRENT_COMPOSITE_CUSTOMER', currentCompositeCustomer);
    },

    setCompositeCustomersList({ commit }, compositeCustomersList) {
      commit('SET_COMPOSITE_CUSTOMERS_LIST', compositeCustomersList);
    },

    setCurrentCompositeCustomer({ commit }, currentCompositeCustomer) {
      commit('SET_CURRENT_COMPOSITE_CUSTOMER', currentCompositeCustomer);
    },
  },
};
